import React from 'react';
import { GoogleOAuthProvider, GoogleLogin } from '@react-oauth/google';
import { Button} from '@mui/material';

const clientId = '2176391335-4kifmrhqlgur6694rpbkjcdvdbqsemiv.apps.googleusercontent.com';

const Login = ({ onSuccess, onFailure }) => {
  
  const handleSuccessResponse = (response) => {
    onSuccess(response.credential);
  };

  const handleFailureResponse = (error) => {
    onFailure(error);
  };

  return (
        <GoogleOAuthProvider clientId={clientId}>
          <GoogleLogin
            onSuccess={handleSuccessResponse}
            onFailure={handleFailureResponse}
            scope="email openid"
            render={({ onClick }) => (
              <Button
                variant="contained"
                color="primary"
                onClick={onClick}
                fullWidth
                size="large"
              >
                Iniciar sesión con Google
              </Button>
            )}
          />
        </GoogleOAuthProvider>
    );
};

export default Login;
